module.exports = __webpack_public_path__ + "static/media/tire-pressure-check-red.b3ef52d0.svg";